import { call, put, take } from 'redux-saga/effects';
import { createUploadFileChannel } from './createUploadChannel';
import { singleFileUploadProgressAction, singleFileUploadSuccessAction } from '../../actions';
import { FileUploadStatus } from '../../enums';
export const singleFileUploadProgressSaga = function* (documentUrl, fileId, file, disableProgressNotification) {
    const uploadFileChannel = yield call(createUploadFileChannel, documentUrl, file);
    while (true) {
        const { progress = 0, status, headers } = yield take(uploadFileChannel);
        switch (status) {
            case FileUploadStatus.FAILED:
                throw new Error('File upload failed');
            case FileUploadStatus.SUCCESS:
                yield put(singleFileUploadSuccessAction({ id: fileId, headers }));
                return;
            case FileUploadStatus.IN_PROGRESS:
                if (!disableProgressNotification) {
                    yield put(singleFileUploadProgressAction({ id: fileId, progress }));
                }
        }
    }
};
//# sourceMappingURL=singleFileUploadProgressSaga.js.map